export default function PriceFormat({value, currency}: { value: number; currency: string }) {
    return (
        <div style={{display: "flex", gap: 10, direction: "ltr"}}>
            <span style={{color: "#666666"}}>{currency}</span>
            <span>{Intl.NumberFormat().format(value)}</span>
        </div>
    );
}
